// extracted by mini-css-extract-plugin
module.exports = {"pricing":"PricingTableOne_pricing__2jdRN","active":"PricingTableOne_active__2-IFY","content":"PricingTableOne_content__mBUEo","price":"PricingTableOne_price__rLqse"};